import styled from "styled-components";
import {useRef} from "react";
import type {SpaceViewRenderer} from "../../../modules/space/spaceeditor/logic3d/renderers/SpaceViewRenderer";
import {colorPalette} from "../../styles/colorPalette";
import {THREEUtils} from "../../../../utils/THREEUtils";
import {fontSize, radius} from "../../styles/styles";
import type {Xyicon3D} from "../../../modules/space/spaceeditor/logic3d/elements3d/Xyicon3D";
import type {BoundarySpaceMap3D} from "../../../modules/space/spaceeditor/logic3d/elements3d/BoundarySpaceMap3D";
import type {Markup3D} from "../../../modules/space/spaceeditor/logic3d/elements3d/markups/abstract/Markup3D";

interface ILockIconTooltipProps {
	readonly spaceViewRenderer: SpaceViewRenderer;
}

export const LockIconTooltip = (props: ILockIconTooltipProps) => {
	const {spaceViewRenderer} = props;
	const _ref = useRef<HTMLDivElement>(null);

	const item = spaceViewRenderer.spaceItemController.lockIconManager.getHoveredItem();
	const iconMaybe = (item as Xyicon3D | BoundarySpaceMap3D | Markup3D)?.lockIconPosition;

	const style = THREEUtils.getStyleForFloatingUIElement(iconMaybe?.x, iconMaybe?.y, item?.position.z, spaceViewRenderer, true, "top", _ref.current);
	style.top = "30px";
	style.position = "absolute";
	style.left = "75px";

	return (
		<TooltipStyled
			ref={_ref}
			style={style}
		>
			Locked Position
		</TooltipStyled>
	);
};

const TooltipStyled = styled.div`
	background-color: ${colorPalette.blueGray.c950};
	height: 20px;
	border-radius: ${radius.xs};
	padding: 2px 4px;
	color: ${colorPalette.white};
	font-size: ${fontSize.sm};
	line-height: 16px;
`;
